import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { CodeSnippetComponent } from "../../common/code-snippet/code-snippet.component";

/**
 * A component for displaying a mapping view in a modal dialog.
 * This component showcases method names and their corresponding code snippets,
 * along with additional information about the filename, user story, and test case.
 */
@Component({
  selector: "app-mapping-view",
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    CodeSnippetComponent,
  ],
  templateUrl: "./mapping-view.component.html",
  styleUrls: ["./mapping-view.component.scss"],
})
export class MappingViewComponent {
  filename = "BookingDates.java";
  userStory =
    "As a Project Manager, I want to create a new project, so that I can organize and manage tasks within a specific project context As a Project Manager, I want to create a new project, so that I can organize and manage tasks within a specific project context.";
  testCase = "Verify Getter and Setter for Checkout";

  displayedColumns: string[] = ["methodName", "codeSnippet"];
  dataSource = [
    {
      methodName: "getCheckout",
      codeSnippet: "public String getCheckout() { return checkout; } ",
    },
    {
      methodName: "getCheckin",
      codeSnippet: "public String getCheckin() { return checkin; }",
    },
    {
      methodName: "setCheckout",
      codeSnippet:
        "public void setCheckout(String checkout) { this.checkout = checkout; }",
    },
  ];

  /**
   * Constructor for initializing the MappingViewComponent.
   * @param dialogRef The reference to the modal dialog, allowing the component to close the dialog.
   */
  constructor(private dialogRef: MatDialogRef<MappingViewComponent>) {}

  /**
   * Closes the modal dialog when invoked.
   */
  closeDialog(): void {
    this.dialogRef.close();
  }
}
